import React, { createContext, useContext, useMemo } from 'react';
import { DEFAULT_LOCALE, isLocale, type Locale } from './config';
import { getCopy } from './index';
import type { LocaleCopy } from './types';

interface LocaleInfo {
  locale: Locale;
  basePath: string;
  localized: boolean;
}

const LocaleContext = createContext<LocaleInfo>({
  locale: DEFAULT_LOCALE,
  basePath: '/',
  localized: false,
});

interface LocaleProviderProps {
  pageContext: Record<string, unknown>;
  children: React.ReactNode;
}

export function LocaleProvider({ pageContext, children }: LocaleProviderProps): React.JSX.Element {
  const locale = isLocale(pageContext.locale) ? pageContext.locale : DEFAULT_LOCALE;
  const basePath = typeof pageContext.basePath === 'string' ? pageContext.basePath : '/';
  const localized = pageContext.localized === true;
  const value = useMemo(() => ({ locale, basePath, localized }), [locale, basePath, localized]);
  return <LocaleContext.Provider value={value}>{children}</LocaleContext.Provider>;
}

export function useLocaleInfo(): LocaleInfo {
  return useContext(LocaleContext);
}

export function useCopy(): LocaleCopy {
  return getCopy(useContext(LocaleContext).locale);
}
